import { apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';
import { createPaginationParams } from 'APIPackage/MainModule/common/createPaginationParams';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IPaginationParams } from 'APIPackage/MainModule/interfaces/IPaginationParams';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';

import { IKnmEditor } from '../interfaces/IKnmEditor';
import { IKnmHistoryItem } from '../interfaces/IKnmHistoryItem';
import { IKnmLink } from '../interfaces/IKnmLink';
import { IPreviousKnmFilter } from '../interfaces/IPreviousKnmFilter';
import { IPreviousKnmPage } from '../interfaces/IPreviousKnmPage';

interface IFetchKnmFindPrevious extends IPaginationParams {
  data: IPreviousKnmFilter;
}

export async function fetchKnmFindPrevious({
  data,
  ...paginationParams
}: IFetchKnmFindPrevious): Promise<IPreviousKnmPage> {
  const queryParams = createPaginationParams(paginationParams);
  const isFederalLaw248: boolean = getLawInterfaceFromStorage() === LawInterfacesEnum.FZ_248;

  isFederalLaw248 && queryParams.set('isFederalLaw248', String(isFederalLaw248));

  return apiPost<IPreviousKnmPage>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/find-previous${
      queryParams.toString().length ? `?${queryParams}` : ''
    }`,
    body: data,
  });
}

export async function fetchKnmHistory(id: number): Promise<IKnmHistoryItem[]> {
  return apiGet<IKnmHistoryItem[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/history`);
}

export async function fetchKnmSignedHistory(
  id: number,
  startDateTime: string,
  endDateTime: string,
): Promise<IKnmHistoryItem[]> {
  const urlSearchParams = new URLSearchParams();

  urlSearchParams.append('startDateTime', startDateTime);
  urlSearchParams.append('endDateTime', endDateTime);

  return apiGet<IKnmHistoryItem[]>(
    `${getServiceBaseURL(APIServiceEnum.KNM_SERVICE)}/knm/${id}/changes-for-sign?${urlSearchParams}`,
  );
}

export async function fetchKnmLinks(id: number): Promise<IKnmLink[]> {
  return apiGet<IKnmLink[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/links`);
}

export async function fetchKnmResultDecisionLinks(id: number): Promise<IKnmLink[]> {
  return apiGet<IKnmLink[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${id}/resultDecisionLinks`);
}

export async function fetchKnmEditorsByKnmId(knmId: number): Promise<IKnmEditor[]> {
  return apiPut<IKnmEditor[]>(`/erknm-editors/api/knm/${knmId}`);
}

export async function fetchUserWriteAccessToKnmById(knmId: number): Promise<boolean> {
  return apiGet<boolean>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/${knmId}/has-write-access`);
}
